module.exports = __webpack_public_path__ + "media/images/icons/copy-text-4b743692d1c5a0b62f9e0dd3ac933224.svg";